import Typography from "@material-ui/core/Typography";
// @ts-ignore
import CopyToClipboardChip from "hcla-web-frontend-primitives/app/components/primitives/Chips/CopyToClipboardChip";
import React from "react";
import {QRLabelMapJSON} from "../../../Quantification/QuantificationResultJSON";
import BasicEventRMChip from "../../Chips/BasicEventRMChip";
import {WrappedComponentProps} from "react-intl";
import {TreeContext} from "../../../SingleHCLModelView/TreeContext";
import NodeLabel from "../../NodeLabel/NodeLabel";

interface Props extends WrappedComponentProps {
	noSlide: boolean;
	title: string;
	loading: boolean;
	loadingText: string;
	noDataText: string;
	treeType: string;
	sequenceName: string;
	importanceData: string;
	map: QRLabelMapJSON;
}

interface tableCellData {
	Conditional: number;
	Criticality: number;
	Diagnostic: number;
	Marginal: number;
	Potential: number;
	RAW: number;
	RRW: number;
	basic_event: string;
	scenario: string;
}

interface RowInfo {
	/** Materialized row of data */
	row: any;

	/** The post-accessed values from the original row */
	rowValues: any;

	/** The index of the row */
	index: number;

	/** The index of the row relative to the current page */
	viewIndex: number;

	/** The size of the page */
	pageSize: number;

	/** The index of page */
	page: number;

	/** The nesting depth (zero-indexed) */
	level: number;

	/** The nesting path of the row */
	nestingPath: number[];

	/** A boolean stating if the row is an aggregation row */
	aggregated: boolean;

	/** A boolean stating if the row is grouped by Pivot */
	groupedByPivot: boolean;

	/** An array of any expandable sub-rows contained in this row */
	subRows: any[];

	/** Original object passed to row */
	original: any;

	// Value from data for the given cell
	value: any;
}

const ImportanceDataTableColumnsComparison = (props: Props) => {
	const { intl, classes, map } = props;

  const makeAccessor = (param, comparison: {before: any, after: any}, type) => {
		let chip = <CopyToClipboardChip label={param.toExponential(3)} classes={{ root: classes.fullWidth }} />
		if(param !== null || param !== undefined){
			let colorParam = classes.successBG; //greater than / success
			if(type === "Success" && comparison.before > comparison.after){
				colorParam = classes.failureBG;
			}
			if(type === "Failure" && comparison.before < comparison.after){
				colorParam = classes.failureBG;
			}
			if(comparison.before == comparison.after){
				colorParam = classes.defaultBG;
			}

			chip = <CopyToClipboardChip label={param.toExponential(3)} classes={{ root: colorParam }} />
		}

		return <div className={classes.rowItem}>{chip}</div>;
	}

	const getColor = (param, compParam, type) => {
		let colorParam = '#4CAF50'; //greater than / success
		if (param !== null || param !== undefined) {
			if(type === "Success" && param < compParam){
				colorParam = '#F44336';
			}
			if(type === "Failure" && param > compParam){
				colorParam = '#F44336';
			}
			if(param == compParam){
				colorParam = 'darkgray';
			}
		}

		return colorParam;
	}

	return ([
		{
			id: 'basic_event',
			width: 250,
			Header: (
				<Typography variant="h6" align="center">
					{/*
          // @ts-ignore */}
					{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.basic_event'}, undefined, undefined, undefined, undefined)}
				</Typography>
			),
			accessor: (d: tableCellData) => d.basic_event,
			Cell: (row: RowInfo) => (
				<div className={classes.cutsetRow}>
					<div className={classes.cutsetRowItem}>
						<TreeContext.Consumer>
							{
								value => (
									<BasicEventRMChip map={map} name={row.value} treeId={value.treeId} />
								)
							}
						</TreeContext.Consumer>
					</div>
				</div>
			),
		},
		{
			id: 'conditional_before',
			width: 250,
			accessor: 'Conditional Before',
			Cell: (row: RowInfo) => makeAccessor(row.row.conditional_before, {before: row.row.conditional_before, after: row.row.conditional_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.conditional_after, rowInfo.row.conditional_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/* // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.conditional'}, undefined, undefined, undefined, undefined)} Before
			</Typography>,
		},
		{
			id: 'conditional_after',
			width: 250,
			accessor: 'Conditional After',
			Cell: (row: RowInfo) => makeAccessor(row.row.conditional_after, {before: row.row.conditional_before, after: row.row.conditional_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.conditional_after, rowInfo.row.conditional_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/* // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.conditional'}, undefined, undefined, undefined, undefined)} After
			</Typography>,
		},
		{
			id: 'marginal_before',
			width: 250,
			accessor: 'Marginal Before',
			Cell: (row: RowInfo) => makeAccessor(row.row.marginal_before, {before: row.row.marginal_before, after: row.row.marginal_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.marginal_after, rowInfo.row.marginal_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/*
        // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.marginal'}, undefined, undefined, undefined, undefined)} Before
			</Typography>,
		},
		{
			id: 'marginal_after',
			width: 250,
			accessor: 'Marginal After',
			Cell: (row: RowInfo) => makeAccessor(row.row.marginal_after, {before: row.row.marginal_before, after: row.row.marginal_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.marginal_after, rowInfo.row.marginal_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/*
        // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.marginal'}, undefined, undefined, undefined, undefined)} After
			</Typography>,
		},
		{
			id: 'potential_before',
			width: 250,
			accessor: 'Potential Before',
			Cell: (row: RowInfo) => makeAccessor(row.row.potential_before, {before: row.row.potential_before, after: row.row.potential_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.potential_after, rowInfo.row.potential_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/*
        // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.potential'}, undefined, undefined, undefined, undefined)} Before
			</Typography>,
		},
		{
			id: 'potential_after',
			width: 250,
			accessor: 'Potential After',
			Cell: (row: RowInfo) => makeAccessor(row.row.potential_after, {before: row.row.potential_before, after: row.row.potential_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.potential_after, rowInfo.row.potential_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/*
        // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.potential'}, undefined, undefined, undefined, undefined)} After
			</Typography>,
		},
		{
			id: 'criticality_before',
			width: 250,
			accessor: 'Criticality Before',
			Cell: (row: RowInfo) => makeAccessor(row.row.criticality_before, {before: row.row.criticality_before, after: row.row.criticality_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.criticality_after, rowInfo.row.criticality_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/*
         // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.criticality'}, undefined, undefined, undefined, undefined)} Before
			</Typography>,
		},
		{
			id: 'criticality_after',
			width: 250,
			accessor: 'Criticality After',
			Cell: (row: RowInfo) => makeAccessor(row.row.criticality_after, {before: row.row.criticality_before, after: row.row.criticality_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.criticality_after, rowInfo.row.criticality_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/*
         // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.criticality'}, undefined, undefined, undefined, undefined)} After
			</Typography>,
		},
		{
			id: 'diagnostic_before',
			width: 250,
			accessor: 'Diagnostic Before',
			Cell: (row: RowInfo) => makeAccessor(row.row.diagnostic_before, {before: row.row.diagnostic_before, after: row.row.diagnostic_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.diagnostic_after, rowInfo.row.diagnostic_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/*
        // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.diagnostic'}, undefined, undefined, undefined, undefined)} Before
			</Typography>,
		},
		{
			id: 'diagnostic_after',
			width: 250,
			accessor: 'Diagnostic After',
			Cell: (row: RowInfo) => makeAccessor(row.row.diagnostic_after, {before: row.row.diagnostic_before, after: row.row.diagnostic_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.diagnostic_after, rowInfo.row.diagnostic_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/*
        // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.diagnostic'}, undefined, undefined, undefined, undefined)} After
			</Typography>,
		},
		{
			id: 'raw_before',
			width: 250,
			accessor: 'RAW Before',
			Cell: (row: RowInfo) => makeAccessor(row.row.raw_before, {before: row.row.raw_before, after: row.row.raw_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.raw_after, rowInfo.row.raw_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/*
        // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.raw'}, undefined, undefined, undefined, undefined)} Before
			</Typography>,
		},
		{
			id: 'raw_after',
			width: 250,
			accessor: 'RAW After',
			Cell: (row: RowInfo) => makeAccessor(row.row.raw_after, {before: row.row.raw_before, after: row.row.raw_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.raw_after, rowInfo.row.raw_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/*
        // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.raw'}, undefined, undefined, undefined, undefined)} After
			</Typography>,
		},
		{
			id: 'rrw_before',
			width: 250,
			accessor: 'RRW Before',
			Cell: (row: RowInfo) => makeAccessor(row.row.rrw_before, {before: row.row.rrw_before, after: row.row.rrw_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.rrw_after, rowInfo.row.rrw_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/*
        // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.rrw'}, undefined, undefined, undefined, undefined)} Before
			</Typography>,
		},
		{
			id: 'rrw_after',
			width: 250,
			accessor: 'RRW After',
			Cell: (row: RowInfo) => makeAccessor(row.row.rrw_after, {before: row.row.rrw_before, after: row.row.rrw_after}, NodeLabel.buildWithDefaults(map, row.original.endstate).label.name),
			getProps: (state, rowInfo, column) => {
				return {
					style: {
						background: rowInfo && getColor(rowInfo.row.rrw_after, rowInfo.row.rrw_before, NodeLabel.buildWithDefaults(map, rowInfo.original.endstate).label.name)
					},
				};
			},
			Header: <Typography
				variant="h6"
				align="center"
			>
				{/*
        // @ts-ignore */}
				{intl.formatMessage({id: 'ImportanceResultView.Columns.Header.rrw'}, undefined, undefined, undefined, undefined)} After
			</Typography>,
		},
	]);
};

export default (ImportanceDataTableColumnsComparison);
